export type MitarbeiterFelder = {
  personalnr: string;
  vorname: string;
  nachname: string;
  standort: string;
  spalte: string;
};

export type AbgleichFeld = keyof MitarbeiterFelder;

// Alle Felder, die zwischen e2n und DATEV verglichen werden.
export const ABGLEICH_FELDER = [
  'personalnr',
  'vorname',
  'nachname',
  'standort',
  'spalte',
] as const satisfies readonly AbgleichFeld[];

export type AbgleichZeile = {
  id: string;
  e2n: MitarbeiterFelder | null;
  datev: MitarbeiterFelder | null;
  abweichendeFelder: AbgleichFeld[];
};

export type MitarbeiterabgleichZusammenfassung = {
  uebereinstimmend: number;
  gesamt: number;
  letzterAbruf: string;
};

export type MitarbeiterabgleichQuelle = {
  e2nMitarbeiter: MitarbeiterFelder[];
  datevMitarbeiter: MitarbeiterFelder[];
  letzterAbruf: string;
};
